import {FAILURE, PENDING, SUCCESS} from '../constants'

export const UD_FAILURE = `GET_USER_DETAIL_${FAILURE}`
export const UD_PENDING = `GET_USER_DETAIL_${PENDING}`
export const UD_SUCCESS = `GET_USER_DETAIL_${SUCCESS}`
